import type { FunctionalComponent } from 'preact';
import type { PageProps } from '@/types/props.ts';

const NotFound: FunctionalComponent<PageProps> = () => (
  <div class="page">
    <header class="title">
      <span class="nav-title">페이지를 찾을 수 없습니다</span>
    </header>

    <div class="section">
      <div class="contents" style={{ padding: '1.5rem' }}>
        <p>요청하신 페이지가 없거나 주소가 변경되었습니다.</p>
        <a href="/">홈으로</a>
      </div>
    </div>
  </div>
);

export default NotFound;
